(function () {
  'use strict';
  angular.module('vcdrug')
    .component('drugeditor', {
      restrict: 'E',
      bindings: {
        drug: '<',
        parentsave: '&',
        parentadd: '&',
        oncancel: '&'
      },
      templateUrl: 'vcdrug/drugeditor-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Drug', 'Config', 'vertxEventBusService',
        function ($log, Drug, Config, vertxEventBusService) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;

          vm.$onInit = function () {
            vm.lastdrug = angular.copy(vm.drug);
            vm.tmpdrug = angular.copy(vm.drug);

            Config.$find('drugconfig').$then(function (sigs) {
              //  vm.conf.drugsignature.length
              vm.conf = sigs;
              // intialize if still empty
              if (!angular.isArray(vm.conf.drugsignature)) {
                vm.drugsignature.drugsignature = [];
              }
              if (!angular.isString(vm.conf._id)) {
                vm.drugsignature._id = 'drugconfig';
              }
            });

          };


          function save() {
            vm.lastdrug = angular.copy(vm.tmpdrug);
            vm.parentsave({drug: vm.tmpdrug});
          }

          function cancel() {
            vm.canceled = true;
            vm.oncancel();
          }


          // update dugsignature list TODO: doesnt work, needs backend update message
          vertxEventBusService.on('config.update', function (message) {
            $log.debug('******** config update received: ', message);
            let messages = message.split(':');
            if (messages[0] === 'drugsignature') {
              vm.conf.$refresh().$then(function () {
                $log.debug('******* config refresh drugsignatures');
              }, function (error) {
                $log.debug('******* config refresh drugsignatures failed: ', error);
              });
            }
          });

          vm.sprsignature = `W&auml;hlen Sie aus der Liste oder geben Sie eine andere Anweisung ein.
            Sie k&ouml;nnen die Auswahlliste im Einstellungsmenu unter Einstellungen &auml;ndern.`;
          vm.sprpkgsize = `Die Packungsgr&ouml;&szlig;e wird bei Medikamenten, die von der Krankenkasse erstattet werden,
            automatisch ausfeg&uuml;ellt.`;
          vm.sprpkgnr = `Wenn f&uuml;r langzeitbewilligbare Medikamente mehr als drei Packungen erforderlich sind,
            vermerken Sie das bitte unter dem L\'x\' Hinweis im Rezeptvermerk.`;
          vm.sprduration = `Anla&szlig;bezogene Medikation (z.B. Antibiotika) wird 14 Tage nach der Verschreibung automatisch deaktiviert
             und ist danach nur noch in der Medikationshostorie ersichtlich.
             Dauermedikation (z.B. Beta-Blocker) verbleibt in der Medikamentenliste des Patienten bis Sie es manuell absetzen.`;


        }] // controllerkde
    }); // component

// klammerfriedhof
}());
